import { isHttpsUrl, type BlockComponentProps } from "./shared"

export function MapBlock({ content, resolved }: BlockComponentProps) {
  const mapAddr = (content?.address as string) ?? ""
  const mapH = (content?.heading as string) ?? ""
  const mapHeight = (content?.height as number) ?? 300
  if (!isHttpsUrl(mapAddr)) return null
  const mapSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-6"} ${resolved.cornerClass} ${resolved.alignClass} max-w-4xl mx-auto`.trim()
    : "px-4 py-6 @sm:px-6 @md:px-8 max-w-4xl mx-auto"
  return (
    <section className={mapSectionClass} style={resolved.sectionStyle}>
      {mapH && <h2 className="text-xl font-bold mb-4">{mapH}</h2>}
      <iframe
        src={mapAddr}
        title={mapH || "Map"}
        className="w-full rounded-lg border-0"
        style={{ height: mapHeight }}
        sandbox="allow-scripts allow-same-origin"
      />
    </section>
  )
}
